import { Tabs, Tab, TabList, TabPanel, Button } from '@panwds/react-ui'
import DeploymentProfilesTable from './DeploymentProfilesTable'
import { VFC, useState } from 'react'
import LicenseTable from '../../tenancy/components/licenses/LicenseTable'
import styled from 'styled-components'
import { Tooltip } from '@panwds/react-ui-legacy'
import { PencilIcon } from '@panwds/icons'
import { TOOLTIP_EDIT_TENANT } from '../../tenancy/constants/LabelConstants'
import { getVarValue } from '../../common/utils/Sparky'
import { FF_DISABLE_LICENSE_TABLE_EDIT } from '../../common/utils/FeatureFlags'

const CONTAINER = styled.div`
  div[role="tabpanel"] {
    margin: 0 !important;
  }
  div[role="tablist"] {
    border-bottom: none !important;
  }

  div {
    min-height: 0 !important;
  }
`

export const LicenseTab = 'licenseTab'
export const DeploymentProfileTab = 'deploymentProfileTab'
const OneAppLicensePage: VFC<any> = (props) => {
  const disableEditIcon = getVarValue(FF_DISABLE_LICENSE_TABLE_EDIT, false)
  const { onEditLicenses, disableEdit } = props
  const [activeTabId, setActiveTabId] = useState(LicenseTab)
  const [size] = useState<'sm' | 'md' | 'lg'>('lg')

  const getTitle = () => {
    return (
      disableEditIcon ? null : <div className='tw-pr-4'>
        <Tooltip label={TOOLTIP_EDIT_TENANT}>
          <Button
            style={{ background: 'transparent' }}
            aria-label={'license-edit'}
            disabled={disableEdit}
            onClick={onEditLicenses}
            appearance='tertiary-clear'
            addClassName={false ? 'cm-text-disabled' : ''}
            icon={<PencilIcon />} />
        </Tooltip>
      </div>
    )
  }
  return (
    // <div className='tw-w-full tw-h-full tw-flex tw-flex-col tw-rounded tw-border tw-border-solid tw-border-gray-200 dark:tw-border-gray-950 tw-absolute tw-inset-0'>
    // <TableContainer header={getTitle()} style={''}>
    <CONTAINER>
      <Tabs>
        <div className='tw-border tw-border-gray-300 tw-border-solid tw-border-b-0 tw-rounded-t-lg dark:tw-border-gray-950'>
          <div className='tw-flex tw-justify-between tw-pt-2 tw-pl-4'>
            {/*<Title size='xxs' addClassName={'text-gray-900'} level={2}>{header}</Title>*/}
            Licenses
            {getTitle()}
          </div>
          <TabList activeTabId={activeTabId} onActiveChange={(nextTabId) => setActiveTabId(nextTabId)}>
            <Tab id={LicenseTab} size={size}>
              Licensed Products
            </Tab>
            <Tab id={DeploymentProfileTab} size={size}>
              Deployment Profiles
            </Tab>
          </TabList>
        </div>
        <TabPanel activeTabId={activeTabId} forTabId={LicenseTab}>
          <LicenseTable {...props}></LicenseTable>
        </TabPanel>
        <TabPanel activeTabId={activeTabId} forTabId={DeploymentProfileTab}>
          <DeploymentProfilesTable {...props} />
        </TabPanel>
      </Tabs>
    </CONTAINER>
    //</TableContainer>

  // </div>
  )
}

export default OneAppLicensePage
